import React from "react";


const TPRMcreate = () => {
  document.title = "tprm-create";

  return (
    <React.Fragment>
      <div className="page-content">

        <h1>tprm-create</h1>
        
      </div>
    </React.Fragment>
  );
};

export default TPRMcreate;
